module.exports = __webpack_public_path__ + "img/generarcard.c3dd2043.png";